import { render, staticRenderFns } from "./index.html?vue&type=template&id=9bde7a8a&scoped=true&external"
import script from "./Microsoft.vue?vue&type=script&lang=js"
export * from "./Microsoft.vue?vue&type=script&lang=js"
import style0 from "./Microsoft.vue?vue&type=style&index=0&id=9bde7a8a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bde7a8a",
  null
  
)

export default component.exports